/* eslint-disable react-redux/useSelector-prefer-selectors */
import { useAppSelector } from '../../../../stores/redux.store';
import type { RootState } from '../../../../stores/redux.store';
import { BasePageState, BaseRedirectState } from '../../../../utilities/hooks/pageStateTypes';

export type SignupWelcomeStateResult = BaseRedirectState | SignupWelcomePageState;

type WelcomeSlice = RootState['welcome'];
type AppConfigSlice = RootState['appConfig'];
type MicrobrandingSlice = RootState['microbranding'];
type MarketingConsentSlice = RootState['marketingConsent'];

export type SignupWelcomePageState = BasePageState &
  Pick<AppConfigSlice, 'auth0Config' | 'recaptchaEnable'> &
  Pick<
    WelcomeSlice,
    | 'displayName'
    | 'email'
    | 'error'
    | 'fieldErrors'
    | 'formError'
    | 'isLoading'
    | 'recoveryToken'
    | 'redirectTo'
    | 'redirectType'
    | 'shouldSkipCaptcha'
  > & {
    csrfToken: RootState['csrfToken'];
    oidcContext: MicrobrandingSlice['oidcContext'];
    isEmbedded: boolean;
    marketingConsentConfig: MarketingConsentSlice['config'];
  };

export const useWelcomeState = () => {
  const csrfToken = useAppSelector(state => state.csrfToken);
  const oidcContext = useAppSelector(state => state.microbranding.oidcContext);
  const isEmbedded = useAppSelector(state => Boolean(state.microbranding.isEmbedded));
  const marketingConsentConfig = useAppSelector(state => state.marketingConsent.config);

  const { recaptchaEnable, auth0Config } = useAppSelector(state => state.appConfig);
  const {
    displayName,
    email,
    error,
    fieldErrors,
    formError,
    isLoading,
    recoveryToken,
    redirectTo,
    redirectType,
    shouldSkipCaptcha,
  } = useAppSelector(state => state.welcome);

  const state: SignupWelcomePageState = {
    type: 'page-state',
    auth0Config,
    csrfToken,
    displayName,
    email: email || '',
    error,
    fieldErrors,
    formError,
    isEmbedded,
    isLoading,
    marketingConsentConfig,
    oidcContext,
    recaptchaEnable,
    recoveryToken,
    redirectTo,
    redirectType,
    shouldSkipCaptcha,
  };

  return {
    state,
    isLoading: false,
    isError: false,
    isSuccess: true,
    error: undefined,
  };
};
